import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Constant } from "../../general/blog/constant";
import { environment } from "../../../../environments/environment";
import { CommonModule } from "@angular/common";
import { Meta, Title } from "@angular/platform-browser";
import { PortalImagePipe } from "../../../common/pipe/portal-image-standalone.pipe";

@Component({
  selector: "introduce-robo",
  standalone: true,
  imports: [CommonModule, PortalImagePipe],
  templateUrl: "./introduce-robo.component.html",
  styleUrls: ['./introduce-robo.component.scss'],
})

export class IntroduceRoboComponent implements OnInit {
  Constant = Constant;
  isLoad: boolean = false;
  referralCode: string = '';
  isMobile: any = false;
  linkRegister: string = '';
  constructor(
    public meta: Meta,
    public title: Title,
    private route: ActivatedRoute,
  ) {
  }
  ngOnInit() {
    this.setSEOMeta();
    const params: any = this.route.snapshot.queryParams;
    this.referralCode = params.referralCode;
    this.linkRegister = Constant.url_register_investor_portal  + '?referralCode=' + this.referralCode;
    if (typeof window === 'undefined') {
      return;
    }
    localStorage.setItem('referralCode', this.referralCode);
    localStorage.setItem('partnerId', '');
    localStorage.setItem('agencyPartnerCode', '');
    localStorage.setItem('thirdAppId', '');
  }
  setSEOMeta() {
    this.title.setTitle('Giới thiệu nhận thưởng - Agency Fmarket - fmarket');
    this.meta.updateTag({ property: 'og:title', content: 'Giới thiệu nhận thưởng - Robo Fmarket - fmarket' });
    this.meta.updateTag({
      property: 'og:description',
      content: 'Giới thiệu nhận thưởng - Robo Fmarket - fmarket',
    });
    this.meta.updateTag({
      property: 'og:image',
      content: environment.domain + 'trade/assets/images/robo/roboF.svg',
    });
    this.meta.updateTag({
      name: 'keywords',
      content: `Giới thiệu, nhận thưởng, Robo, Fmarket, fmarket `,
    });
    this.meta.updateTag({ property: 'og:url', content: environment.domain + Constant.path_robo + '/' + this.referralCode });
  }
}
